
export class PublicoAlvoPlanejamentoOficina {
    id: number;
    descricao: string;
    idPlanejamentoOficina: number;
	idPublicoAlvo: number;
    idUsuarioAplicacao: number;
	idInstituicao: number;
}